<template>
	<div class="recharge">
		<div class="main" v-if="!chenggong">
			<div class="title" v-text="title"></div>
			<ul>
				<li>
					<input type="number" placeholder="请输入手机号码" v-model="phone" />
					<i class="close" v-if="phone !== ''" @click="phone = ''">×</i>
				</li>
				<li v-if="type != '1'">
					<input type="number" placeholder="请输入油卡号码" v-model="youka" />
					<i class="close" v-if="youka !== ''" @click="youka = ''">×</i>
				</li>
			</ul>
			<div class="shuju">
				<div class="col" v-for="(item, index) in listjine" :key="index">
					<div @click="xuanze(item)" :class="jine == item ? 'item active' : 'item'" v-text="item + '元'"></div>
				</div>
			</div>
			<div class="chongzhi" @click="chongzhi">充值</div>
		</div>
		<div class="chenggong" v-if="chenggong">
			<img src="@/static/images/other/chenggong.png" />
			<p class="green">恭喜你，充值成功。</p>
			<div class="backIndex" @click="backIndex">返回首页</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	data() {
		return {
			chenggong: false,
			type: this.$route.query.type,
			title: '', //
			listjine: [],
			phone: '', //手机号
			youka: '', //油卡号
			jine: '100' //金额
		};
	},
	computed: {
		...mapState(['userInfo'])
	},
	mounted() {
		if (this.type == '1') {
			this.title = '充话费';
			this.listjine = [10, 30, 50, 100, 200, 500];
		}
		if (this.type == '2') {
			this.title = '中国石化';
			this.listjine = [50, 100, 200, 300, 500, 800, 1000];
		}
		if (this.type == '3') {
			this.title = '中国石油';
			this.listjine = [50, 100, 200, 300, 500, 800, 1000];
		}
	},
	//方法
	methods: {
		backIndex() {
			this.$router.push({ path: '/' });
		},
		xuanze(item) {
			this.jine = item;
		},
		chongzhi() {
			if (this.phone === '') {
				this.$toast({
					message: '请输入手机号',
					duration: 1000
				});
				return;
			}
			if (!this.regularPhone(this.phone)) {
				this.$toast({
					message: '请输入正确的手机号',
					duration: 1000
				});
				return;
			}
			if (this.type != '1' && this.youka == '') {
				this.$toast({
					message: '请输入油卡号码',
					duration: 1000
				});
				return;
			}
			if (this.jine === '') {
				this.$toast({
					message: '请选择充值金额',
					duration: 1000
				});
				return;
			}
			var obj = {
				memberId: this.userInfo.memberId,
				type: this.type == '1' ? '1' : '2', //充值类型(1话费充值2油卡充值)
				mobile: this.phone, //充值手机号、持卡人手机号
				price: this.jine //充值价格
			};
			if (this.type != '1') {
				obj.oilCompany = this.type == '2' ? '1' : '2'; //油卡公司类型(1:中石化 2:中石油)
				obj.oilAccount = this.youka; //油卡号
			}
			this.post(this.apis.rechargeWithPoints, obj)
				.then(response => {
					this.$toast({
						message: response.data.retMsg,
						duration: 1000
					});
					if (response.data.retCode == 'SUCCESS') {
						this.chenggong = true;
					}
				})
				.catch(error => {
					console.log(error);
				});
		}
	}
};
</script>

<style lang="less" scoped>
.recharge {
	padding: 60px 70px;
	font-size: 28px;
	.main {
		.title {
			font-weight: 700;
		}
		li {
			margin-top: 10px;
			height: 104px;
			border-bottom: 1px solid #c5c5c5;
			display: flex;
			justify-content: space-between;
			align-items: center;
			input {
				border: none;
				height: 90px;
				width: 70%;
				outline: none;
				font-size: 30px;
			}
			.close {
				font-style: normal;
				width: 32px;
				height: 32px;
				background-color: #8e8e93;
				font-size: 32px;
				color: #fff;
				border-radius: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 8px;
			}
		}
		.shuju {
			margin: 40px -20px;
			.col {
				width: 33.33%;
				display: inline-block;
				.item {
					margin: 20px;
					border: 1px solid #06ca68;
					text-align: center;
					padding: 35px 0px;
					border-radius: 10px;
					color: #06ca68;
					font-size: 30px;
					font-weight: 700;
					&.active {
						box-shadow: 0 0 15px;
					}
				}
			}
		}
		.chongzhi {
			padding: 26px;
			text-align: center;
			border-radius: 100px;
			background-color: #06ca68;
			color: #fff;
			font-size: 30px;
			font-weight: 700;
		}
	}
	.chenggong {
		padding-top: 200px;
		text-align: center;
		img {
			width: 210px;
			height: 179px;
		}
		p {
			padding-top: 53px;
		}
		.backIndex {
			margin-top: 80px;
			padding: 26px;
			text-align: center;
			border-radius: 100px;
			border: 1px solid #06ca68;
			background-color: #fff;
			color: #06ca68;
			font-size: 30px;
			font-weight: 700;
		}
	}
}
</style>
